/** GLSL the stylized materials share: value noise, the wind, and the soft light. */

/** A hash and a smooth value noise in 3D, in 0..1. No textures, so nothing repeats. */
export const NOISE = /* glsl */ `
float hash13(vec3 p) {
  p = fract(p * 0.1031);
  p += dot(p, p.zyx + 31.32);
  return fract((p.x + p.y) * p.z);
}
float noise3(vec3 p) {
  vec3 i = floor(p);
  vec3 f = fract(p);
  f = f * f * (3.0 - 2.0 * f);
  float a = mix(hash13(i), hash13(i + vec3(1.0, 0.0, 0.0)), f.x);
  float b = mix(hash13(i + vec3(0.0, 1.0, 0.0)), hash13(i + vec3(1.0, 1.0, 0.0)), f.x);
  float c = mix(hash13(i + vec3(0.0, 0.0, 1.0)), hash13(i + vec3(1.0, 0.0, 1.0)), f.x);
  float d = mix(hash13(i + vec3(0.0, 1.0, 1.0)), hash13(i + vec3(1.0, 1.0, 1.0)), f.x);
  return mix(mix(a, b, f.y), mix(c, d, f.y), f.z);
}
`;

/**
 * The wind moves a prop's vertices sideways by the square of their height above its root, so
 * roots stay put and tips swing. Every prop has its own phase from where it stands.
 */
export const WIND = /* glsl */ `
uniform float uTime;
uniform float uWind;
vec3 windSway(vec3 p, vec3 origin, float weight) {
  float h = max(p.y, 0.0);
  float phase = dot(origin, vec3(2.19, 1.53, 1.11));
  float gust = 0.65 + 0.35 * sin(uTime * 0.7 + phase * 0.3);
  float s = uWind * weight * h * h * gust;
  p.x += sin(uTime * 2.3 + phase) * s;
  p.z += cos(uTime * 1.9 + phase * 1.3) * s * 0.7;
  return p;
}
`;

/**
 * The soft light: the sun wraps a little past the terminator, the sky lights from above and the
 * ground bounces warm light from below, and a cool rim (`rim`: how much) outlines shapes against
 * space. Colours come out a little more saturated, like paint.
 */
export const LIGHT = /* glsl */ `
uniform vec3 uSunDir;
uniform vec3 uUpDir;
uniform vec3 uSunColor;
uniform vec3 uSkyColor;
uniform vec3 uGroundColor;
uniform vec3 uRimColor;
vec3 stylizedLight(vec3 albedo, vec3 n, vec3 v, float rim) {
  float wrap = clamp((dot(n, uSunDir) + 0.3) / 1.3, 0.0, 1.0);
  vec3 ambient = mix(uGroundColor, uSkyColor, dot(n, uUpDir) * 0.5 + 0.5);
  float edge = pow(1.0 - clamp(dot(n, v), 0.0, 1.0), 4.0);
  vec3 lit = albedo * (ambient + uSunColor * wrap) + uRimColor * edge * rim * (0.3 + 0.7 * wrap);
  return mix(vec3(dot(lit, vec3(0.299, 0.587, 0.114))), lit, 1.12);
}
`;
